import styled from 'styled-components';
import { mediaQuery, paddings } from '~/styled';

export const WrapperDiv = styled.div`
  padding: ${paddings.defaultPadding} ${paddings.defaultPadding} 0;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.orange600};
  font-weight: 700;

  ${mediaQuery.up.l`
    padding: 0;
    line-height: 48px;
    white-space: nowrap;
  `}
`;
